import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M16.191 12.775a4.083 4.083 0 0 0-.846-1.322c-.875-.901-1.97-1.583-3.262-2.002L9.01 12.524 5.932 9.445c-1.299.419-2.399 1.103-3.278 2.008a4.093 4.093 0 0 0-.846 1.322L0 17.25h18l-1.809-4.475zm-13.27.45a2.88 2.88 0 0 1 .594-.935 6.554 6.554 0 0 1 2.115-1.45l2.533 2.533.849.848.848-.848 2.526-2.526c.804.35 1.508.834 2.099 1.443.245.252.445.567.594.936l1.142 2.825H1.779l1.142-2.826zM9.01 9.25c2.449 0 3.49-2.298 3.49-4.359C12.5 2.751 11.479.75 9.01.75 6.541.75 5.5 2.732 5.5 4.891c0 2.12 1.02 4.359 3.51 4.359zm0-7.3c2.067 0 2.29 2.057 2.29 2.941 0 1.173-.482 3.159-2.29 3.159-2.199 0-2.31-2.631-2.31-3.159 0-.884.225-2.941 2.31-2.941z" />
  </svg>
);

export default SvgComponent;
